"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyStatus$ = exports.CompaniesCompanyStatus$outboundSchema = exports.CompaniesCompanyStatus$inboundSchema = exports.CompaniesCompanyStatus = void 0;
const z = __importStar(require("zod"));
exports.CompaniesCompanyStatus = {
    ActiveProposalToStrikeOff: "Active - Proposal to Strike off",
    InAdministrationReceiverManager: "In Administration/Receiver Manager",
    Liquidation: "Liquidation",
    Receivership: "RECEIVERSHIP",
    InAdministrationAdministrativeReceiver: "In Administration/Administrative Receiver",
    VoluntaryArrangement: "Voluntary Arrangement",
    VoluntaryArrangementReceiverManager: "VOLUNTARY ARRANGEMENT / RECEIVER MANAGER",
    VoluntaryArrangementAdministrativeReceiver: "VOLUNTARY ARRANGEMENT / ADMINISTRATIVE RECEIVER",
    ReceiverManagerAdministrativeReceiver: "RECEIVER MANAGER / ADMINISTRATIVE RECEIVER",
    Active: "Active",
    AdministrationOrder: "ADMINISTRATION ORDER",
    LiveButReceiverManagerOnAtLeastOneCharge: "Live but Receiver Manager on at least one charge",
    AdministrativeReceiver: "ADMINISTRATIVE RECEIVER",
    InAdministration: "In Administration",
    Registered: "Registered",
    RegisteredDissolving: "Registered - Dissolving",
    RegisteredTransferredEngagements: "Registered - Transferred Engagements",
    RegisteredInLiquidation: "Registered - In Liquidation",
    RegisteredCancellationNoticeIssued: "Registered - Cancellation Notice Issued",
    RegisteredAmalgamated: "Registered - Amalgamated",
    Deregistered: "Deregistered",
    RegisteredInAdministration: "Registered - In Administration",
    RegisteredWindingUp: "Registered - Winding Up",
    RegisteredInReceivership: "Registered - In Receivership",
};
/** @internal */
exports.CompaniesCompanyStatus$inboundSchema = z.nativeEnum(exports.CompaniesCompanyStatus);
/** @internal */
exports.CompaniesCompanyStatus$outboundSchema = exports.CompaniesCompanyStatus$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyStatus$;
(function (CompaniesCompanyStatus$) {
    /** @deprecated use `CompaniesCompanyStatus$inboundSchema` instead. */
    CompaniesCompanyStatus$.inboundSchema = exports.CompaniesCompanyStatus$inboundSchema;
    /** @deprecated use `CompaniesCompanyStatus$outboundSchema` instead. */
    CompaniesCompanyStatus$.outboundSchema = exports.CompaniesCompanyStatus$outboundSchema;
})(CompaniesCompanyStatus$ || (exports.CompaniesCompanyStatus$ = CompaniesCompanyStatus$ = {}));
//# sourceMappingURL=companiescompanystatus.js.map